import React from "react";

export const overviewFaq = [
  {
    title: "Buy & Sell Private Shares with Other Investors",
    description: (
      <p className="ml-8">
        The BnkToTheFuture Secondary Market allows you to trade private equity
        shares securely and compliantly. Buy or sell shares held under the
        BnkToTheFuture SPV structure with flexible pricing and investment
        opportunities.
      </p>
    ),
  },
  {
    title: "How it works",
    description: (
      <ol className="list-decimal pl-4 space-y-1 ml-8">
        <li>Verify & Certify – Complete your investor verification.</li>
        <li>
          Place an Order – Choose an existing offer or set your own price.
        </li>
        <li>Confirm Agreement – Pre-sign a legally binding contract.</li>
        <li>
          Settlement & Transfer – Once matched, payments are processed, and
          shares are updated in your portfolio.
        </li>
      </ol>
    ),
  },
  {
    title: "Why Use the Secondary Market?",
    description: (
      <div className="space-y-2 ml-8">
        <div>
          <strong>For Buyers</strong>
          <p>
            Invest in companies beyond initial funding rounds, increase your
            stake, and secure potential discounts.
          </p>
        </div>
        <div>
          <strong>For Sellers</strong>
          <p>
            Access liquidity before an IPO, adjust your portfolio, and receive
            funds directly.
          </p>
        </div>
      </div>
    ),
  },
];

export const tradingFaq = [
  {
    title: "How does trading work?",
    description: (
      <p className="ml-8">
        It's a bulletin board where investors manually match buy and sell
        orders, similar to an Over-The-Counter Market. Due to limited liquidity,
        order fulfillment may take longer than a traditional exchange.
      </p>
    ),
  },
  {
    title: "What is the minimum order amount?",
    description: <p className="ml-8">The minimum trade size is $1,000 USD.</p>,
  },
  {
    title: "How do I start investing?",
    description: (
      <p className="ml-8">
        Complete investor verification, deposit USDT, and browse available
        offers. You can place an instant bid or create a Buy Order with a set
        price.
      </p>
    ),
  },
  {
    title: "What are the fees?",
    description: (
      <p className="ml-8">
        A 2.5% fee applies when a trade is completed (covers share transfer and
        escrow services). No fees for placing unfilled orders.
      </p>
    ),
  },
  {
    title: "Why are my funds blocked when I place an order?",
    description: (
      <p className="ml-8">
        To prevent double-spending, funds are held until the order is either
        filled or canceled, after which they are released for withdrawal or
        reinvestment.
      </p>
    ),
  },
];
